import React from "react";
import { map } from "lodash";

import "./tablePreLoader.scss";

const TablePreloader = (props:any) => {
    return (
      <div className="table-preloader">
        {map(Array.from(Array(props.rows + 1).keys()), (item) => {
          return (
            <div className="table-preloader__row" key={"row_" + item}>
              {map(Array.from(Array(8).keys()), (item) => {
                return (
                  <div key={"col_" + item} className="table-preloader__row__column">
                    <div className="table-preloader__row__column__title shimmerBG"></div>
                    <div className="table-preloader__row__column__sub-title shimmerBG"></div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

export default TablePreloader;